import React, { useState, useEffect } from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { H5, Image } from 'AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Common/Form/Post';
import { submitAdmin } from 'Services/Features/Admin/Utils/adminUtils';
import { setFormData, resetFormData } from 'Services/Features/Admin/adminSlice';
import SelectBranch from './SelectBranch';
import CustomLoader from 'Component/Common/CustomLoader';
import { toast } from 'react-toastify';
import Select from 'react-select';

const AdminForm = ({ label, setRefetch }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const data = useSelector(state => state.admin.currentAdmin)
    const startUpload = useSelector(state => state.admin.loading);

    const handleSuccess = () => {
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/admins`);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let validationMessage = '';
        if(!data.id) {
            if (!data.name) {
                validationMessage = 'Nama tidak boleh kosong';
            } else if (!data.email) {
                validationMessage = 'Email tidak boleh kosong';
            } else if (data.email && !/\S+@\S+\.\S+/.test(data.email)) {
                validationMessage = 'Email tidak valid';
            } else if (!data.password) {
                validationMessage = 'Password tidak boleh kosong';
            } else if (data.password.length < 8) {
                validationMessage = 'Password minimal 8 karakter';
            } else if (!data.is_super_admin && !data.is_admin && !data.is_cs) {
                validationMessage = 'Role tidak boleh kosong';
            } else if (!data.branch_id && (data.is_admin || data.is_cs == 1)) {
                validationMessage = 'Cabang tidak boleh kosong';
            }
        } else {
            if (!data.name) {
                validationMessage = 'Nama tidak boleh kosong';
            } else if (!data.email) {
                validationMessage = 'Email tidak boleh kosong';
            } else if (data.email && !/\S+@\S+\.\S+/.test(data.email)) {
                validationMessage = 'Email tidak valid';
            } else if (!data.is_super_admin && !data.is_admin && !data.is_cs) {
                validationMessage = 'Role tidak boleh kosong';
            } else if (!data.branch_id && (data.is_admin || data.is_cs == 1)) {
                validationMessage = 'Cabang tidak boleh kosong';
            } else if (data.password && data.password.length < 8) {
                validationMessage = 'Password minimal 8 karakter';
            }
        }
        if (validationMessage) {
            toast.error(validationMessage);
            return;
        }
        dispatch(submitAdmin({ ...data, successCallback: handleSuccess }))
    };

    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/admins`);
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        dispatch(setFormData({ [name]: value }));
    }

    const [selectedSortValue, setSelectedSortValue] = useState(null)
    
    const options = [
        { value: 'is_super_admin', label: 'Super Admin' },
        { value: 'is_admin', label: 'Admin' },
        { value: 'is_cs', label: 'Customer Service' },
    ];

    useEffect(() => {
        const selectedCategory = data.is_super_admin ? [{
            value: 'is_super_admin',
            label: 'Super Admin',
        }] : data.is_admin ? [{
            value: 'is_admin',
            label: 'Admin',
        }] : data.is_cs ? [{
            value: 'is_cs',
            label: 'Customer Service',
        }] : selectedSortValue;
        setSelectedSortValue(selectedCategory);
    }, [data.is_super_admin, data.is_admin, data.is_cs]);
        
    const handleSelectChangeSort = (selectedOption) => {
        setSelectedSortValue(selectedOption);
        if (selectedOption) {
            if (selectedOption.value === 'is_super_admin') {
                const newFilters = {
                    ...data,
                    'is_super_admin': 1,
                    'is_admin': 0,
                    'is_cs': 0,
                    'branch_id': null,
                };
                dispatch(setFormData(newFilters));
            } else if (selectedOption.value === 'is_admin') {
                const newFilters = {
                    ...data,
                    'is_super_admin': 0,
                    'is_admin': 1,
                    'is_cs': 0,
                };
                dispatch(setFormData(newFilters));
            } else if (selectedOption.value === 'is_cs') {
                const newFilters = {
                    ...data,
                    'is_super_admin': 0,
                    'is_admin': 0,
                    'is_cs': 1,
                };
                dispatch(setFormData(newFilters));
            }
        } else {
            const newFilters = {
                ...data,
                'is_super_admin': '',
                'is_admin': '',
                'is_cs': '',
            };
            dispatch(setFormData(newFilters));
        }
    }


    return (
        <PostCommon title={label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} >
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <Row className="mb-3">
                    <Col sm={4}>
                        <FormGroup className='mb-3'>
                            <Label for="validationName" style={{ fontWeight: 'bold' }}>Nama :</Label>
                            <Input
                                className="form-control"
                                id="validationName"
                                type="text"
                                name="name"
                                placeholder="Masukkan nama akun..."
                                required=""
                                value={data.name}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={4}>
                        <FormGroup className='mb-3'>
                            <Label for="validationEmail" style={{ fontWeight: 'bold' }}>Email :</Label>
                            <Input
                                className="form-control"
                                id="validationEmail"
                                type="email"
                                name="email"
                                placeholder="Masukkan email akun..."
                                required=""
                                value={data.email}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={4}>
                        <FormGroup className='mb-3'>
                            <Label for="validationPassword" style={{ fontWeight: 'bold' }}>Password :</Label>
                            <Input
                                className="form-control"
                                id="validationPassword"
                                type="text"
                                name="password"
                                placeholder="Masukkan password akun..."
                                required=""
                                value={data.password}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={4}>
                        <FormGroup className='mb-3'>
                            <Label for="validationDesc" style={{ fontWeight: 'bold' }}>Role :</Label>
                            <Select
                                options={options}
                                className="js-example-basic-single"
                                isMulti={false}
                                isClearable={true}
                                placeholder="Find by role.."
                                onChange={handleSelectChangeSort}
                                value={selectedSortValue}
                            />
                        </FormGroup>
                    </Col>
                    { (data.is_admin || data.is_cs == 1) && (
                        <Col sm={4}>
                            <FormGroup className='mb-3'>
                                <Label for="validationDesc" style={{ fontWeight: 'bold' }}>Cabang :</Label>
                                <SelectBranch/>
                            </FormGroup>
                        </Col>
                    )}
                </Row>
            </div>
        </PostCommon>
    );
};

export default AdminForm;